import { getPlatFormImage } from "helpers/format";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

interface Option {
  label: string;
  value: string;
}
interface DropdownOptionImageProps {
  name?: string,
  initialValue?: any | undefined | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean,
  className?: string,
  classNamePrefix?: string,
  isHasOptionAll?: boolean,
  optionAll?: undefined | Option,
  colors?: any,
  isClearable?: boolean
}

const DropdownOptionImage = ({
  name = '',
  initialValue,
  onChangeSelect,
  placeholder,
  disabled = false,
  className = '',
  classNamePrefix = '',
  isHasOptionAll = false,
  optionAll,
  dataList = [],
  isClearable
}: DropdownOptionImageProps) => {
  const { t, i18n } = useTranslation();

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  const resultOption = useMemo(() => {
    return isHasOptionAll ? [optionAll].concat(dataList) : dataList;
  }, [i18n?.language, isHasOptionAll, optionAll]);

  return (
    <React.Fragment>
      <Select
        options={resultOption}
        value={(initialValue || isHasOptionAll) ? resultOption.find((item: any) => item.value === initialValue) : null}
        // value={initialValue ?? resultOption[0]}
        name={name}
        isDisabled={disabled}
        isClearable={isClearable}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ''}</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        formatOptionLabel={(option: any) => {
          let imgPlatform = getPlatFormImage(option?.value);

          return (
            <div className="d-flex align-items-center">
              {
                imgPlatform ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgPlatform ? <img src={imgPlatform} width={20} height={20} alt="platform" /> :
                      <span className={`bg-secondary`} style={{ width: "20px", height: '20px', borderRadius: '3px' }}></span>
                    }
                  </div>
                ) : ''
              }
              <div>
                {t(option?.label)}
              </div>
            </div>
          )
        }
        }
        className={className}
        classNamePrefix={classNamePrefix}
      />
    </React.Fragment>
  );
};

export default DropdownOptionImage;
